import 'react';
import { css } from 'styled-components';
import styledTheming from '../node_modules/styled-theming/index.js';
import '../App.css.js';
var heightButton = styledTheming.variants("layout", "heightButton", {
  xsmall: {
    light: css(["height:24px;min-height:24px;"]),
    dark: css(["height:24px;min-height:24px;"])
  },
  small: {
    light: css(["height:36px;min-height:36px;"]),
    dark: css(["height:36px;min-height:36px;"])
  },
  medium: {
    light: css(["height:48px;min-height:48px;"]),
    dark: css(["height:48px;min-height:48px;"])
  },
  large: {
    light: css(["height:56px;min-height:56px;"]),
    dark: css(["height:56px;min-height:56px;"])
  },
  xlarge: {
    light: css(["height:64px;min-height:64px;"]),
    dark: css(["height:64px;min-height:64px;"])
  }
});
var paddingButton = styledTheming.variants("layout", "heightButton", {
  xsmall: {
    light: "padding: 4px 12px 4px 12px;",
    dark: "padding: 4px 12px 4px 12px;"
  },
  small: {
    light: "padding: 10px 16px 10px 16px;",
    dark: "padding: 10px 16px 10px 16px;"
  },
  medium: {
    light: "padding: 16px 16px 16px 16px;",
    dark: "padding: 16px 16px 16px 16px;"
  },
  large: {
    light: "padding: 20px 24px 20px 24px;",
    dark: "padding: 20px 24px 20px 24px;"
  },
  xlarge: {
    light: "padding: 24px 24px 24px 24px;",
    dark: "padding: 24px 24px 24px 24px;"
  }
});
var borderRadiusSmallRoundedButton = styledTheming.variants("layout", "heightButton", {
  xsmall: {
    light: "border-radius: 8px;",
    dark: "border-radius: 8px;"
  },
  small: {
    light: "border-radius: 12px;",
    dark: "border-radius: 12px;"
  },
  medium: {
    light: "border-radius: 16px;",
    dark: "border-radius: 16px;"
  },
  large: {
    light: "border-radius: 16px;",
    dark: "border-radius: 16px;"
  },
  xlarge: {
    light: "border-radius: 16px;",
    dark: "border-radius: 16px;"
  }
});
var borderRadiusRoundedButton = styledTheming.variants("layout", "heightButton", {
  xsmall: {
    light: "border-radius: 12px;",
    dark: "border-radius: 12px;"
  },
  small: {
    light: "border-radius: 18px;",
    dark: "border-radius: 18px;"
  },
  medium: {
    light: "border-radius: 24px;",
    dark: "border-radius: 24px;"
  },
  large: {
    light: "border-radius: 28px;",
    dark: "border-radius: 28px;"
  },
  xlarge: {
    light: "border-radius: 32px;",
    dark: "border-radius: 32px;"
  }
});
var heightButtonMobile = styledTheming.variants("layout", "heightButton", {
  small: {
    light: "height: 24px",
    dark: "height: 24px"
  },
  medium: {
    light: "height: 36px",
    dark: "height: 36px"
  },
  large: {
    light: "height: 48px",
    dark: "height: 48px"
  },
  xlarge: {
    light: {
      height: "56px",
      minHeight: "56px"
    },
    dark: {
      height: "56px",
      minHeight: "56px"
    }
  }
});
var fontSizeTextButton = styledTheming.variants("layout", "textType", {
  small: {
    light: "font-size: 12px",
    dark: "font-size: 12px"
  },
  medium: {
    light: "font-size: 14px",
    dark: "font-size: 14px"
  },
  large: {
    light: "font-size: 16px",
    dark: "font-size: 16px"
  }
});
var lineHeightTextButton = styledTheming.variants("layout", "textType", {
  small: {
    light: "line-height: 16px",
    dark: "line-height: 16px"
  },
  medium: {
    light: "line-height: 16px",
    dark: "line-height: 16px"
  },
  large: {
    light: "line-height: 20px",
    dark: "line-height: 20px"
  }
});
var textColorButtonActivePrimary = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--white)",
    dark: "color: var(--dark-gray-9)"
  },
  red: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  azure: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  green: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  white: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--dark-gray-9)"
  },
  grayFour: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  },
  grayEight: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  },
  grayNine: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  }
});
var textColorButtonActiveOutlined = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--black)",
    dark: "color: var(--white)"
  },
  red: {
    light: "color: var(--red)",
    dark: "color: var(--dark-red)"
  },
  azure: {
    light: "color: var(--azure-telegram)",
    dark: "color: var(--azure-telegram)"
  },
  green: {
    light: "color: var(--green)",
    dark: "color: var(--green)"
  },
  white: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--dark-gray-9)"
  },
  grayFour: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  },
  grayEight: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  },
  grayNine: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  }
});
var textColorButtonActiveText = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--black)",
    dark: "color: var(--white)"
  },
  red: {
    light: "color: var(--red)",
    dark: "color: var(--dark-red)"
  },
  azure: {
    light: "color: var(--azure-telegram)",
    dark: "color: var(--azure-telegram)"
  },
  green: {
    light: "color: var(--green)",
    dark: "color: var(--green)"
  },
  white: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--dark-gray-9)"
  },
  grayFour: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  },
  grayEight: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  },
  grayNine: {
    light: "color: var(--light-gray-9)",
    dark: "color: var(--white)"
  }
});
styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--black)",
    dark: "color: var(--white)"
  },
  red: {
    light: "color: var(--red)",
    dark: "color: var(--dark-red)"
  },
  azure: {
    light: "color: var(--azure-telegram)",
    dark: "color: var(--azure-telegram)"
  },
  green: {
    light: "color: var(--green)",
    dark: "color: var(--green)"
  }
});
var textColorButtonDisabledPrimary = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  red: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  azure: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  green: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  white: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayFour: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayEight: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayNine: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  }
});
var textColorButtonDisabledOutlined = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  red: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  azure: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  green: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  white: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayFour: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayEight: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayNine: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  }
});
var textColorButtonDisabledText = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  red: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  azure: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  green: {
    light: "color: var(--dark-gray-1)",
    dark: "color: var(--dark-gray-1)"
  },
  white: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayFour: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayEight: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  },
  grayNine: {
    light: "color: var(--light-gray-2)",
    dark: "color: var(--dark-gray-2)"
  }
});
var textColorButtonActivePrimaryHover = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--dark-gray-9)",
    dark: "color: var(--white)"
  },
  red: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  azure: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  green: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  grayFour: {
    light: "color: var(--main)",
    dark: "color: var(-main)"
  },
  grayEight: {
    light: "color: var(--main)",
    dark: "color: var(--main)"
  },
  grayNine: {
    light: "color: var(--main)",
    dark: "color: var(--main)"
  }
});
var textColorButtonActiveOutlinedHover = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--white)",
    dark: "color: var(--main)"
  },
  red: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  azure: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  },
  green: {
    light: "color: var(--white)",
    dark: "color: var(--white)"
  }
});
var textColorButtonActiveTextHover = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "color: var(--white)",
    dark: "color: var(--main)"
  },
  red: {
    light: "color: var(--red)",
    dark: "color: var(--dark-red)"
  },
  azure: {
    light: "color: var(--azure-telegram)",
    dark: "color: var(--azure-telegram)"
  },
  green: {
    light: "color: var(--green)",
    dark: "color: var(--green)"
  }
});
var textColorButtonActive = styledTheming.variants("layout", "type", {
  primary: {
    light: css(["", ""], textColorButtonActivePrimary),
    dark: css(["", ""], textColorButtonActivePrimary)
  },
  secondary: {
    light: css(["color:var(--light-gray-9);"]),
    dark: css(["color:var(--white);"])
  },
  outlined: {
    light: css(["", ""], textColorButtonActiveOutlined),
    dark: css(["", ""], textColorButtonActiveOutlined)
  },
  text: {
    light: css(["", ""], textColorButtonActiveText),
    dark: css(["", ""], textColorButtonActiveText)
  }
});
var textColorButtonActiveHover = styledTheming.variants("layout", "type", {
  primary: {
    light: css(["", ""], textColorButtonActivePrimaryHover),
    dark: css(["", ""], textColorButtonActivePrimaryHover)
  },
  secondary: {
    light: css(["color:var(--light-gray-9);"]),
    dark: css(["color:var(--white);"])
  },
  outlined: {
    light: css(["", ""], textColorButtonActiveOutlinedHover),
    dark: css(["", ""], textColorButtonActiveOutlinedHover)
  },
  text: {
    light: css(["", ""], textColorButtonActiveTextHover),
    dark: css(["", ""], textColorButtonActiveTextHover)
  }
});
var textColorButtonDisabled = styledTheming.variants("layout", "type", {
  primary: {
    light: css(["", ""], textColorButtonDisabledPrimary),
    dark: css(["", ""], textColorButtonDisabledPrimary)
  },
  secondary: {
    light: css(["color:var(--light-gray-2);"]),
    dark: css(["color:var(--dark-gray-2);"])
  },
  outlined: {
    light: css(["", ""], textColorButtonDisabledOutlined),
    dark: css(["", ""], textColorButtonDisabledOutlined)
  },
  text: {
    light: css(["", ""], textColorButtonDisabledText),
    dark: css(["", ""], textColorButtonDisabledText)
  }
});
var backgroundColorButtonActivePrimary = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: var(--dark-gray-9)",
    dark: "background-color: var(--white)"
  },
  red: {
    light: "background-color: var(--red)",
    dark: "background-color: var(--red)"
  },
  azure: {
    light: "background-color: var(--azure-telegram)",
    dark: "background-color: var(--azure-telegram)"
  },
  green: {
    light: "background-color: var(--green)",
    dark: "background-color: var(--green)"
  },
  white: {
    light: "background-color: var(--white)",
    dark: "background-color: var(--white)"
  },
  grayFour: {
    light: "background-color: var(--light-gray-4)",
    dark: "background-color: var(--dark-gray-4)"
  },
  grayEight: {
    light: "background-color: var(--light-gray-8)",
    dark: "background-color: var(--dark-gray-8)"
  },
  grayNine: {
    light: "background-color: var(--light-gray-9)",
    dark: "background-color: var(--dark-gray-9)"
  }
});
var backgroundColorButtonActivePrimaryHover = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: var(--white)",
    dark: "background-color: var(--dark-gray-9)"
  },
  red: {
    light: "background-color: var(--red-hover)",
    dark: "background-color: var(--red-hover)"
  },
  azure: {
    light: "background-color: var(--azure-hover)",
    dark: "background-color: var(--azure-hover)"
  },
  white: {
    light: "background-color: var(--light-gray-7)",
    dark: "background-color: var(--light-gray-7)"
  },
  green: {
    light: "background-color: var(--green-hover)",
    dark: "background-color: var(--green-hover)"
  },
  grayFour: {
    light: "background-color: var(--light-gray-6)",
    dark: "background-color: var(--dark-gray-3)"
  },
  grayEight: {
    light: "background-color: var(--light-gray-7)",
    dark: "background-color: var(--dark-gray-7)"
  },
  grayNine: {
    light: "background-color: var(--light-gray-2)",
    dark: "background-color: var(--dark-gray-2)"
  }
});
var backgroundColorButtonActiveOutlinedHover = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: var(--black)",
    dark: "background-color: var(--white)"
  },
  red: {
    light: "background-color: var(--red-hover)",
    dark: "background-color: var(--red-hover)"
  },
  azure: {
    light: "background-color: var(--azure-hover)",
    dark: "background-color: var(--azure-hover)"
  },
  green: {
    light: "background-color: var(--green-hover)",
    dark: "background-color: var(--green-hover)"
  },
  grayFour: {
    light: "background-color: var(--light-gray-6)",
    dark: "background-color: var(--dark-gray-6)"
  },
  grayEight: {
    light: "background-color: var(--light-gray-7)",
    dark: "background-color: var(--dark-gray-7)"
  },
  grayNine: {
    light: "background-color: var(--light-gray-2",
    dark: "background-color: var(--dark-gray-2)"
  }
});
var backgroundColorButtonActiveTextHover = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: var(--black-04)",
    dark: "background-color: var(--black-04)"
  },
  red: {
    light: "background-color: var(--black-04)",
    dark: "background-color: var(--black-04)"
  },
  azure: {
    light: "background-color: var(--black-04)",
    dark: "background-color: var(--black-04)"
  },
  green: {
    light: "background-color: var(--black-04)",
    dark: "background-color: var(--black-04)"
  },
  grayFour: {
    light: "background-color: var(--black-04)",
    dark: "background-color: var(--black-04)"
  },
  grayEight: {
    light: "background-color: var(--black-04)",
    dark: "background-color: var(--black-04)"
  },
  grayNine: {
    light: "background-color: var(--black-04)",
    dark: "background-color: var(--black-04)"
  }
});
var backgroundColorButtonActiveOutlined = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  red: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  azure: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  green: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayFour: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayEight: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayNine: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  }
});
var backgroundColorButtonActiveText = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  red: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  azure: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  green: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayFour: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayEight: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayNine: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  }
});
var backgroundColorButtonDisabledPrimary = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: var(--light-gray-6)",
    dark: "background-color: var(--dark-gray-6)"
  },
  red: {
    light: "background-color: var(--light-gray-6)",
    dark: "background-color: var(--dark-gray-6)"
  },
  azure: {
    light: "background-color: var(--light-gray-6)",
    dark: "background-color: var(--dark-gray-6)"
  },
  green: {
    light: "background-color: var(--light-gray-6)",
    dark: "background-color: var(--dark-gray-6)"
  },
  grayFour: {
    light: "background-color: var(--black-08)",
    dark: "background-color: var(--black-08)"
  },
  grayEight: {
    light: "background-color: var(--black-08)",
    dark: "background-color: var(--black-08)"
  },
  grayNine: {
    light: "background-color: var(--black-08)",
    dark: "background-color: var(--black-08)"
  }
});
var backgroundColorButtonDisabledOutlined = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  red: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  azure: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  green: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  grayFour: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayEight: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayNine: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  }
});
var backgroundColorButtonDisabledText = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  red: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  azure: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  green: {
    light: "background-color: trasparent",
    dark: "background-color: trasparent"
  },
  grayFour: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayEight: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayNine: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  }
});
styledTheming.variants("layout", "color", {
  baseColor: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  red: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  azure: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  green: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayFour: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayEight: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  },
  grayNine: {
    light: "background-color: transparent",
    dark: "background-color: transparent"
  }
});
var backgroundColorButtonActive = styledTheming.variants("layout", "type", {
  primary: {
    light: css(["", ""], backgroundColorButtonActivePrimary),
    dark: css(["", ""], backgroundColorButtonActivePrimary)
  },
  secondary: {
    light: css(["background-color:var(--light-gray-4);"]),
    dark: css(["background-color:var(--dark-gray-4);"])
  },
  outlined: {
    light: css(["", ""], backgroundColorButtonActiveOutlined),
    dark: css(["", ""], backgroundColorButtonActiveOutlined)
  },
  text: {
    light: css(["", ""], backgroundColorButtonActiveText),
    dark: css(["", ""], backgroundColorButtonActiveText)
  }
});
var backgroundColorButtonActiveHover = styledTheming.variants("layout", "type", {
  primary: {
    light: css(["", ""], backgroundColorButtonActivePrimaryHover),
    dark: css(["", ""], backgroundColorButtonActivePrimaryHover)
  },
  secondary: {
    light: css(["background-color:var(--light-gray-6);"]),
    dark: css(["background-color:var(--dark-gray-6);"])
  },
  outlined: {
    light: css(["", ""], backgroundColorButtonActiveOutlinedHover),
    dark: css(["", ""], backgroundColorButtonActiveOutlinedHover)
  },
  text: {
    light: css(["", ""], backgroundColorButtonActiveTextHover),
    dark: css(["", ""], backgroundColorButtonActiveTextHover)
  }
});
var backgroundColorButtonDisabled = styledTheming.variants("layout", "type", {
  primary: {
    light: css(["", ""], backgroundColorButtonDisabledPrimary),
    dark: css(["", ""], backgroundColorButtonDisabledPrimary)
  },
  secondary: {
    light: css(["background-color:var(--light-gray-6);"]),
    dark: css(["background-color:var(--dark-gray-6);"])
  },
  outlined: {
    light: css(["", ""], backgroundColorButtonDisabledOutlined),
    dark: css(["", ""], backgroundColorButtonDisabledOutlined)
  },
  text: {
    light: css(["", ""], backgroundColorButtonDisabledText),
    dark: css(["", ""], backgroundColorButtonDisabledText)
  }
});
/*export const borderRadiusRoundedButton = theme("layout", {
  light: css`
      calc(${heightButton}/2)
    `,
  dark: css`
      calc(${heightButton}/2)
    `,
});

export const borderRadiusSmallRoundedButton = theme("layout", {
  light: css`
      12px
    `,
  dark: css`
      12px
    `,
});

export const borderRadiusUnsetButton = theme("layout", {
  light: "none",
  dark: "none",
});*/

var borderButtonActive = styledTheming.variants("layout", "color", {
  baseColor: {
    light: "border: solid 2px var(--black)",
    dark: "border: solid 2px var(--white)"
  },
  red: {
    light: "border: solid 2px var(--red)",
    dark: "border: solid 2px var(--dark-red)"
  },
  azure: {
    light: "border: solid 2px var(--azure-telegram)",
    dark: "border: solid 2px var(--azure-telegram)"
  },
  green: {
    light: "border: solid 2px var(--green)",
    dark: "border: solid 2px var(--green)"
  },
  white: {
    light: "border: solid 2px var(--white)",
    dark: "border: solid 2px var(--white)"
  },
  grayFour: {
    light: "border: solid 2px var(--light-gray-4);",
    dark: "border: solid 2px var(--dark-gray-4);"
  }
});
var borderButtonDisabled = styledTheming.variants("layout", "type", {
  primary: {
    light: "border: none",
    dark: "border: none"
  },
  text: {
    light: "border: none",
    dark: "border: none"
  },
  outlined: {
    light: "border: solid 2px var(--dark-gray-1)",
    dark: "border: solid 2px var(--dark-gray-1)"
  }
});
var borderButtonHover = styledTheming.variants("layout", "color", {
  main: {
    light: "border: solid 2px var(--black)",
    dark: "border: solid 2px var(--white)"
  },
  red: {
    light: "border: solid 2px var(--red-hover)",
    dark: "border: solid 2px var(--red-hover)"
  },
  azure: {
    light: "border: solid 2px var(--azure-hover)",
    dark: "border: solid 2px var(--azure-hover)"
  },
  green: {
    light: "border: solid 2px var(--green-hover)",
    dark: "border: solid 2px var(--green-hover)"
  },
  white: {
    light: "border: solid 2px var(--light-gray-7)",
    dark: "border: solid 2px var(--dark-gray-7)"
  },
  grayFour: {
    light: "border: solid 2px var(--light-gray-6);",
    dark: "border: solid 2px var(--dark-gray-6);"
  }
});
var borderButtonTypeHover = styledTheming.variants("layout", "type", {
  outlined: {
    light: css(["", ""], borderButtonHover),
    dark: css(["", ""], borderButtonHover)
  },
  primary: {
    light: "border: none",
    dark: "border: none"
  },
  text: {
    light: "border: none",
    dark: "border: none"
  }
});
var borderButtonNoBorderHover = styledTheming.variants("layout", "noBorder", {
  false: {
    light: css(["", ""], borderButtonTypeHover),
    dark: css(["", ""], borderButtonTypeHover)
  },
  true: {
    light: "border: none",
    dark: "border: none"
  }
});
var backgroundColorButton = styledTheming.variants("layout", "active", {
  true: {
    light: css(["", ""], backgroundColorButtonActive),
    dark: css(["", ""], backgroundColorButtonActive)
  },
  false: {
    light: css(["", ""], backgroundColorButtonDisabled),
    dark: css(["", ""], backgroundColorButtonDisabled)
  }
});
var backgroundColorButtonHover = styledTheming.variants("layout", "active", {
  true: {
    light: css(["", ""], backgroundColorButtonActiveHover),
    dark: css(["", ""], backgroundColorButtonActiveHover)
  },
  false: {
    light: "",
    dark: ""
  }
});
/*export const borderRadiusButton = theme.variants("layout", "borderRadiusType", {
  rounded: {
    light: css`
      ${borderRadiusRoundedButton}
    `,
    dark: css`
      ${borderRadiusRoundedButton}
    `,
  },
  smallRounded: {
    light: css`
      ${borderRadiusSmallRoundedButton}
    `,
    dark: css`
      ${borderRadiusSmallRoundedButton}
    `,
  },
  unset: {
    light: css`
      ${borderRadiusUnsetButton}
    `,
    dark: css`
      ${borderRadiusUnsetButton}
    `,
  },
});*/

var borderButton = styledTheming.variants("layout", "active", {
  true: {
    light: css(["", ""], borderButtonActive),
    dark: css(["", ""], borderButtonActive)
  },
  false: {
    light: css(["", ""], borderButtonDisabled),
    dark: css(["", ""], borderButtonDisabled)
  }
});
var borderButtonType = styledTheming.variants("layout", "type", {
  outlined: {
    light: css(["", ""], borderButton),
    dark: css(["", ""], borderButton)
  },
  primary: {
    light: "border: none",
    dark: "border: none"
  },
  text: {
    light: "border: none",
    dark: "border: none"
  }
});
var borderButtonNoBorder = styledTheming.variants("layout", "noBorder", {
  false: {
    light: css(["", ""], borderButtonType),
    dark: css(["", ""], borderButtonType)
  },
  true: {
    light: "border: none",
    dark: "border: none"
  }
});
var textColorButton = styledTheming.variants("layout", "active", {
  true: {
    light: css(["", ""], textColorButtonActive),
    dark: css(["", ""], textColorButtonActive)
  },
  false: {
    light: css(["", ""], textColorButtonDisabled),
    dark: css(["", ""], textColorButtonDisabled)
  }
});
var textColorButtonHover = styledTheming.variants("layout", "active", {
  true: {
    light: css(["", ""], textColorButtonActiveHover),
    dark: css(["", ""], textColorButtonActiveHover)
  },
  false: {
    light: "",
    dark: ""
  }
});
var borderRadiusButton = styledTheming.variants("layout", "borderRadiusType", {
  rounded: {
    light: css(["", ""], borderRadiusRoundedButton),
    dark: css(["", ""], borderRadiusRoundedButton)
  },
  smallRounded: {
    light: css(["", ""], borderRadiusSmallRoundedButton),
    dark: css(["", ""], borderRadiusSmallRoundedButton)
  }
});
var buttonSizeStyle = styledTheming("layout", {
  light: css(["", " ", " ", " ", ";", ";"], heightButton, borderRadiusButton, paddingButton, backgroundColorButton, borderButtonNoBorder),
  dark: css(["", " ", " ", " ", ";", ";"], heightButton, borderRadiusButton, paddingButton, backgroundColorButton, borderButtonNoBorder)
});
var genericButtonStyle = styledTheming("layout", {
  light: css(["transition:0.3s;user-select:none;", ""], buttonSizeStyle),
  dark: css(["transition:0.3s;user-select:none;", ""], buttonSizeStyle)
});
export { backgroundColorButton, backgroundColorButtonActive, backgroundColorButtonActiveHover, backgroundColorButtonActiveOutlined, backgroundColorButtonActiveOutlinedHover, backgroundColorButtonActivePrimary, backgroundColorButtonActivePrimaryHover, backgroundColorButtonActiveText, backgroundColorButtonActiveTextHover, backgroundColorButtonDisabled, backgroundColorButtonDisabledOutlined, backgroundColorButtonDisabledPrimary, backgroundColorButtonDisabledText, backgroundColorButtonHover, borderButton, borderButtonActive, borderButtonDisabled, borderButtonHover, borderButtonNoBorder, borderButtonNoBorderHover, borderButtonType, borderButtonTypeHover, borderRadiusButton, borderRadiusRoundedButton, borderRadiusSmallRoundedButton, buttonSizeStyle, fontSizeTextButton, genericButtonStyle, heightButton, heightButtonMobile, lineHeightTextButton, paddingButton, textColorButton, textColorButtonActive, textColorButtonActiveHover, textColorButtonActiveOutlined, textColorButtonActiveOutlinedHover, textColorButtonActivePrimary, textColorButtonActivePrimaryHover, textColorButtonActiveText, textColorButtonActiveTextHover, textColorButtonDisabled, textColorButtonDisabledOutlined, textColorButtonDisabledPrimary, textColorButtonDisabledText, textColorButtonHover };